var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-bag',
                        view: publicPath + 'sprite.svg#view-icon-bag',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/bag',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };